import { MouseEventHandler, useState, TouchEventHandler } from 'react';

import FolderIcon from '@material-ui/icons/Folder';
import { Slide, Typography, Button, Divider } from "@material-ui/core/";
import CheckIcon from '@material-ui/icons/Check'
import { FolderApuntado } from '../Modelos/FolderApuntado';
import { GetRandomColor } from '../Utils/ColorHelper';
import { useHistory } from 'react-router-dom';
import { PathSeparator } from '../Modelos/Search';
import { ReplaceAll } from '../Utils/StringUtils';


export default function FolderApuntadoItem(props: {
    folderApuntado: FolderApuntado,
    removeApuntado: (a: FolderApuntado) => void
}) {

    const history = useHistory();

    const [mouseDownDate, setMouseDownDate] = useState(0);

    const handleMouseDown: MouseEventHandler<HTMLButtonElement> = () => {
        setMouseDownDate(new Date().getTime());
    };

    const handleMouseUp: MouseEventHandler<HTMLButtonElement> = () => {
        mouseUp();
    };

    const mouseUp = () => {
        var delta = new Date().getTime() - mouseDownDate;
        if (delta > 1000) { //long click
            props.removeApuntado(props.folderApuntado);
        } else {//click
            history.push("/sub?full=1&path=" + encodeURI(ReplaceAll(props.folderApuntado.FullPath, " / ", PathSeparator)));
        }
    };

    const handleTouchStart: TouchEventHandler<HTMLButtonElement> = (e) => {
        setMouseDownDate(new Date().getTime());
    };

    const handleTouchEnd: TouchEventHandler<HTMLButtonElement> = (e) => {
        mouseUp();
    };

    return (
        <div>
            <Slide direction="right" in mountOnEnter>
                <div>
                    <Button
                        variant="text"
                        fullWidth
                        color="primary"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            paddingRight: 0, paddingTop: 10, paddingLeft: 0, paddingBottom: 10,
                            textTransform: "none"
                        }}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                    >
                        <div style={{ flex: "auto", display: "flex", flexDirection: "row", alignItems: "stretch", paddingLeft: 8 }}>
                            <div style={{ flex: "0 0 auto", }}>
                                <FolderIcon htmlColor={GetRandomColor(props.folderApuntado.GetNombreToShow())} style={{ marginTop: 2, marginRight: 0, fontSize: 30 }} />
                            </div>
                            <div style={{ flex: "1 1 auto", display: "flex", flexDirection: "column", marginLeft: 8 }}>
                                <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 0, marginRight: 40 }}>
                                    <Typography variant="h6" align="left" style={{ fontSize: 14, fontWeight: "lighter", color: "#999999" }}>
                                        {props.folderApuntado.GetNombreToShow()}
                                    </Typography>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", marginTop: 1 }}>
                                    <Typography style={{ fontSize: 10, fontWeight: "lighter", color: "#cccccc" }}>
                                        {props.folderApuntado.GetTotalSizeText()}
                                    </Typography>
                                    <Typography style={{ fontSize: 10, fontWeight: "lighter", color: "#cccccc", marginLeft: 10 }}>
                                        {props.folderApuntado.GetCantidadDeAudiovisuales()}
                                    </Typography>
                                </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ flex: 1, display: "flex", flexDirection: "row-reverse", marginRight: 15 }}>
                                    <CheckIcon style={{ fontSize: 22, color: "#EF9A9A" }} />
                                </div>
                            </div>
                        </div>
                    </Button>
                    <Divider light style={{ marginLeft: 8, marginRight: 8 }} />
                </div>
            </Slide>
        </div>
    );
}

